module.exports = __webpack_public_path__ + "assets/img/chronicleImgActive-90610cb8.png";